/**
 * Status zlecenia w TMS klienta (W / P / C / Z) — etykiety dla operatora.
 * Znaczenie ustalone z danych (API: `user-offers/tms-order-status.ts`).
 */
export const TMS_ORDER_STATUS_LABELS: Record<string, string> = {
  W: 'nieobsadzone',
  P: 'obsadzone',
  C: 'w realizacji',
  Z: 'zrealizowane',
};

/** „P — obsadzone”; nieznana wartość wprost, brak — kreska. */
export const tmsOrderStatusText = (code: unknown): string => {
  if (typeof code !== 'string' || code === '') return '—';
  const label = TMS_ORDER_STATUS_LABELS[code];
  return label ? `${code} — ${label}` : code;
};

/** Wybór w filtrze listy — klucz filtra `tmsOrderStatus` bez zmian. */
export const TMS_ORDER_STATUS_CHOICES = Object.entries(TMS_ORDER_STATUS_LABELS).map(
  ([id, label]) => ({ id, name: `${id} — ${label}` }),
);
